/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter/types';
import { DetailedUserDto, DetailedUsersListDto, NewUserData, UserStatus } from './usersClient.typings';
import { delayedResponse, makeMockResponse } from '../mockUtils';
import { detailedUserFactory } from './usersFactories';

const DETAILED_USERS_URL = /\/users$/;
const USER_DETAILS_URL = /\/users\/\d+/;
const USER_PASSWORD_URL = /\/users\/\d+\/password/;
const BLOCK_USER_URL = /\/users\/\d+\/block/;
const UNBLOCK_USER_URL = /\/users\/\d+\/unblock/;
const DELETE_USER_URL = /\/users\/\d+\/delete/;
const ADD_USER_URL = /\/users\/add/;

export function addUsersMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onGet(DETAILED_USERS_URL).reply((config) => {
        const data: DetailedUsersListDto = {
            count: 40,
            users: detailedUserFactory.list({ count: 20 }),
        };

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 200);
    });

    mockAdapter.onGet(USER_DETAILS_URL).reply((config) => {
        const data: DetailedUserDto = detailedUserFactory.item();

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 1000);
    });

    mockAdapter.onPatch(USER_PASSWORD_URL).reply((config) => {
        return delayedResponse(
            makeMockResponse(
                200, //403,
                null,
                config,
            ),
            Math.random() * 1000,
        );
    });

    mockAdapter.onPatch(BLOCK_USER_URL).reply((config) => {
        const data: DetailedUserDto = detailedUserFactory.item();
        data.id = parseInt(config.url.split('/')[2]);
        data.status = UserStatus.Inactive;

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 1000);
    });

    mockAdapter.onPatch(UNBLOCK_USER_URL).reply((config) => {
        const data: DetailedUserDto = detailedUserFactory.item();
        data.id = parseInt(config.url.split('/')[2]);
        data.status = UserStatus.Active;

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 1000);
    });

    mockAdapter.onDelete(DELETE_USER_URL).reply((config) => {
        const data: DetailedUserDto = detailedUserFactory.item();
        data.id = parseInt(config.url.split('/')[2]);
        data.status = UserStatus.Deleted;

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 1000);
    });

    mockAdapter.onPost(ADD_USER_URL).reply((config) => {
        const data: DetailedUserDto = detailedUserFactory.item();
        const updatedFields: NewUserData = JSON.parse(config.data);

        for (const key in updatedFields) {
            if (data.hasOwnProperty(key)) {
                data[key as keyof DetailedUserDto] = updatedFields[key as keyof NewUserData];
            }
        }

        return delayedResponse(
            makeMockResponse(
                200, //403,
                data,
                config,
            ),
            Math.random() * 1000,
        );
    });

    mockAdapter.onPatch(USER_DETAILS_URL).reply((config) => {
        const data: DetailedUserDto = detailedUserFactory.item();
        data.id = parseInt(config.url.split('/')[2]);
        const updatedFields: NewUserData = JSON.parse(config.data);

        for (const key in updatedFields) {
            if (data.hasOwnProperty(key)) {
                data[key as keyof DetailedUserDto] = updatedFields[key as keyof NewUserData];
            }
        }

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 1000);
    });
}
